import { render, staticRenderFns } from "./VaimoTruncatedText.vue?vue&type=template&id=be18313e&scoped=true&"
import script from "./VaimoTruncatedText.vue?vue&type=script&lang=ts&"
export * from "./VaimoTruncatedText.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoTruncatedText.vue?vue&type=style&index=0&id=be18313e&prod&lang=scss&scoped=true&"
import style1 from "./VaimoTruncatedText.vue?vue&type=style&index=1&id=be18313e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be18313e",
  null
  
)

export default component.exports